import { z } from 'zod';
import { RoleSchema } from './auth';
export const LawyerProfileInputSchema = z.object({
    barNumber: z.string().max(50).optional().nullable(),
    barAssociation: z.string().max(200).optional().nullable(),
    specialties: z.array(z.string().max(100)).max(20).optional(),
    signature: z.string().max(2000).optional().nullable(),
    /** F10: tarifa horaria en céntimos/hora. Null usa fallback del bufete. */
    hourlyRateCents: z.number().int().min(0).nullable().optional(),
    /** A4: emisor con el que factura cuando es el abogado responsable de un expediente. */
    issuerId: z.string().nullable().optional(),
});
export const CreateUserSchema = z.object({
    email: z.string().email('Email no válido'),
    fullName: z.string().min(2, 'Nombre demasiado corto').max(200),
    role: RoleSchema,
    lawyerProfile: LawyerProfileInputSchema.optional(),
});
export const UpdateUserSchema = z.object({
    fullName: z.string().min(2).max(200).optional(),
    role: RoleSchema.optional(),
    isActive: z.boolean().optional(),
    lawyerProfile: LawyerProfileInputSchema.nullable().optional(),
});
export const UserListItemSchema = z.object({
    id: z.string(),
    email: z.string(),
    fullName: z.string(),
    role: RoleSchema,
    isActive: z.boolean(),
    mustChangePassword: z.boolean(),
    lastLoginAt: z.string().datetime().nullable(),
    isLawyer: z.boolean(),
    /** A4: emisor con el que factura cuando es el abogado responsable (null si no es abogado o no tiene). */
    lawyerIssuerId: z.string().nullable(),
    createdAt: z.string().datetime(),
});
export const UserDetailSchema = UserListItemSchema.extend({
    lawyerProfile: z
        .object({
        barNumber: z.string().nullable(),
        barAssociation: z.string().nullable(),
        specialties: z.array(z.string()),
        signature: z.string().nullable(),
        hourlyRateCents: z.number().int().nullable(),
        issuerId: z.string().nullable(),
    })
        .nullable(),
});
export const CreateUserResponseSchema = z.object({
    user: UserDetailSchema,
    tempPassword: z.string(),
});
export const ResetPasswordResponseSchema = z.object({
    tempPassword: z.string(),
});
//# sourceMappingURL=users.js.map